<template>
  <div class="relative">
    <AthleteSectionHeading>Academic</AthleteSectionHeading>
    <AthleteAcademicEmptyState v-if="showEmptyState" ref="AthleteAcademicEmptyState" />
    <div v-else>
      <AthleteAcademicStatus ref="AthleteAcademicStatus" />
      <AthleteTestScores v-if="!isUserWithoutAccess" ref="AthleteTestScores" />
      <div v-if="!isUserWithoutAccess" class="flex flex-wrap mb-8 -mx-3">
        <div v-if="user.extracurricularActivities || user.academicHonors" class="w-full px-3">
          <AthleteSectionSubheading>Additional Academic Info</AthleteSectionSubheading>

          <div class="block px-4 py-4 overflow-hidden bg-white rounded shadow md:hidden">
            <div class="grid gap-4 grid-cols-none sm:grid-cols-2 md:grid-cols-3">
              <div class="w-full ml-0 md:ml-6">
                <MaxHeightExpandingContent v-if="user.academicHonors" :max-height="192">
                  <div class="w-full mb-6 md:mb-0 overflow-wrap">
                    <h4 class="m-0 font-bold text-gray-700 uppercase ds-text-base">Academic Honors</h4>
                    <div class="w-full mt-3 mb-4 bg-gray-300 h-1px" />
                    <p
                      data-test-id="sm-academicHonors"
                      class="m-0 font-normal ds-text-base list-fix"
                      v-html="user.academicHonors"
                    />
                  </div>
                </MaxHeightExpandingContent>
              </div>
              <div class="w-full ml-0 md:ml-6">
                <MaxHeightExpandingContent v-if="user.extracurricularActivities" :max-height="192">
                  <div class="w-full overflow-wrap">
                    <h4
                      class="m-0 font-bold text-gray-700 uppercase ds-text-base"
                    >
                      Extracurricular Activities
                    </h4>
                    <div class="w-full mt-3 mb-4 bg-gray-300 h-1px" />

                    <p
                      data-test-id="sm-extracurricularActivities"
                      class="m-0 font-normal ds-text-base list-fix"
                      v-html="user.extracurricularActivities"
                    />
                  </div>
                </MaxHeightExpandingContent>
              </div>
            </div>
          </div>

          <MaxHeightExpandingCard :height="196" class="hidden w-full px-0 md:block">
            <div class="flex flex-row flex-wrap md:flex-no-wrap">
              <div v-if="user.academicHonors" class="w-full px-4 mb-6 md:mb-0 overflow-wrap">
                <h4 class="m-0 font-bold text-gray-700 uppercase ds-text-base">Academic Honors</h4>
                <div class="w-full mt-3 mb-4 bg-gray-300 h-1px" />
                <p
                  data-test-id="md-academicHonors"
                  class="m-0 font-normal ds-text-base list-fix"
                  v-html="user.academicHonors"
                />
              </div>
              <div v-if="user.extracurricularActivities" class="w-full px-4 overflow-wrap">
                <h4
                  class="m-0 font-bold text-gray-700 uppercase ds-text-base"
                >
                  Extracurricular Activities
                </h4>
                <div class="w-full mt-3 mb-4 bg-gray-300 h-1px" />

                <p
                  data-test-id="md-extracurricularActivities"
                  class="m-0 font-normal ds-text-base list-fix"
                  v-html="user.extracurricularActivities"
                />
              </div>
            </div>
          </MaxHeightExpandingCard>
        </div>
      </div>

      <AthleteTranscripts v-if="!isUserWithoutAccess" ref="AthleteTranscripts" />
    </div>
    <OTGAthleteTestScores v-if="isLoggedOut" ref="OTGAthleteTestScores" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MaxHeightExpandingCard from "../MaxHeightExpandingCard.vue";
import AthleteSectionHeading from "../../AthleteSectionHeading.vue";
import AthleteSectionSubheading from "../../AthleteSectionSubheading.vue";
import AthleteTestScores from "./AthleteTestScores.vue";
import AthleteTranscripts from "./AthleteTranscripts.vue";
import AthleteAcademicStatus from "./AthleteAcademicStatus.vue";
import OTGAthleteTestScores from "../../OTG/OTGAthleteTestScores.vue";
import MaxHeightExpandingContent from "../MaxHeightExpandingContent.vue";
import AthleteAcademicEmptyState from "./EmptyState/AthleteAcademicEmptyState.vue";

export default {
  components: {
    AthleteAcademicEmptyState,
    MaxHeightExpandingCard,
    AthleteSectionHeading,
    AthleteSectionSubheading,
    AthleteTestScores,
    AthleteTranscripts,
    AthleteAcademicStatus,
    OTGAthleteTestScores,
    MaxHeightExpandingContent,
  },
  computed: {
    ...mapState({
      user: state => state.athleteProfile.user,
    }),
    ...mapGetters({
      isLoggedOut: "userData/isLoggedOut",
      isUserWithoutAccess: "athleteProfile/isUserWithoutAccess",
      hasAcademicInfo: "athleteProfile/hasAcademicInfo",
    }),
    showEmptyState() {
      return !this.hasAcademicInfo && !this.isLoggedOut;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .font-normal > p {
  font-weight: 400 !important;
}

.list-fix {
  /deep/ ul {
    padding-left: 18px !important;
  }

  /deep/ ol {
    padding-left: 18px;
  }
}

.overflow-wrap {
  overflow-wrap: anywhere;
}
</style>
